import Vue from 'vue'
import Vuex from 'vuex'

//import qs from 'qs';
Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    rp: {
      acronym: '',
      stylesheet: new File([''], 'filename')
    },
    rps: [],
    availableRPs: [],
    igs: [],
    validationCycles: []
  },
  getters: {
    getRP: state => {
      return state.rp
    },
    getRPs: state => {
      return state.rps
    },
    getAvailableRPs: state => {
      return state.availableRPs
    },
    getIGs: state => state.igs,
    getValidationCycles: state => state.validationCycles
  },
  actions: {
    clearRPs(context) {
      context.commit('loadRPs', [])
    },
    setValidationCycles (context, validationCycles) {
      context.commit('setValidationCycles', validationCycles)
    },
    loadIGs ({ commit, rootGetters }, { filter, perPage, page }) {
      return Vue.axios
        .get('/api/responsibleParty/igs/list', {
          params: {
            responsibleParty: { id: rootGetters['petra/rps/getRP'].id },
            filter: filter,
            perPage: perPage,
            page: page
          }
        })
        .then(res => {
          commit('IGS', res.data.ingestionSites)
          return res.data
        })
    },
    saveRP (context, rp) {
      let formData = new FormData()
      Object.keys(rp).forEach((item, i) => {
        if (rp[item] && rp[item].toString().length)
          formData.append(item, rp[item])
      })

      formData.append('name', rp.name)
      formData.append('acronym', rp.acronym)
      if (rp.stylesheet) {
        formData.append('stylesheet', rp.stylesheet)
      }
      return Vue.axios.post('/api/rp/save', formData).then(res => {
        let rp = JSON.parse(res.data.object)
        return rp
      })
    },
    loadRPs (context, validationCycle) {
      Vue.axios
        .get('/api/rp/list', {
          params: {
            validationCycle: validationCycle
          }
        })
        .then(res => {
          context.commit('loadRPs', res.data.rps)
        })
    },
    clearRP (context) {
      context.commit('saveRP', {
        stylesheet: new File([''], 'filename')
      })
    },
    async uploadFile ({ dispatch }, data) {
      return dispatch('upload' + data.type, data)
    },
    async uploadDTL (context, data) {
      let formData = new FormData()
      formData.append('rp', data.rp)
      formData.append('validationCycle', data.validationCycle)
      formData.append('file', data.file)
      return await Vue.axios.post('/api/dtl/import', formData).then(res => {
        return res.data
      })
    },
    async uploadDSL (context, data) {
      let formData = new FormData()
      formData.append('rp', data.rp)
      formData.append('validationCycle', data.validationCycle)
      formData.append('file', data.file)
      return await Vue.axios
        .post('/api/dsl/upload', formData, {
          timeout: 300000
        })
        .then(res => {
          return res.data
        })
    },
    loadRP (context, rpId) {
      return Vue.axios
        .get('/api/rp/load', {
          params: {
            id: rpId
          }
        })
        .then(res => {
          context.commit('saveRP', JSON.parse(res.data.responsibleParty))
          context.commit('IGS', [])
          return JSON.parse(res.data.responsibleParty)
        })
    },
    loadAvailableRPs (context, validationCycle) {
      Vue.axios
        .get('/api/rp/available', {
          params: {
            validationCycle: validationCycle.id
          }
        })
        .then(res => {
          context.commit('availableRPs', res.data)
        })
    },
    loadValidationCycles (context, rpId) {
      return Vue.axios
        .get('/api/rp/validationCycles/list', {
          params: {
            rpId: rpId
          }
        })
        .then(res => {
          return res.data
        })
    }
  },
  mutations: {
    setValidationCycles (state, validationCycles) {
      state.validationCycles = validationCycles
    },
    saveRP (state, rp) {
      state.rp = rp
    },
    loadRPs (state, rps) {
      state.rps = rps
    },
    availableRPs (state, rps) {
      state.availableRPs = rps
    },
    IGS: (state, igs) => (state.igs = igs)
  }
}
